import { apiClient } from '@/shared/lib/apiClient';
import type {
  AdminInstapayReviewItem,
  AdminInstapayReviewsListResponse,
  ListAdminInstapayReviewsQuery,
  ReviewInstapayPaymentBody,
} from '../types/adminInstapayReview';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export async function listAdminInstapayReviews(
  query?: ListAdminInstapayReviewsQuery,
): Promise<AdminInstapayReviewsListResponse> {
  const params: Record<string, string> = {};
  if (query?.cursor) params['cursor'] = query.cursor;
  if (query?.limit !== undefined) params['limit'] = String(query.limit);
  if (query?.status) params['status'] = query.status;
  if (query?.tenant_id) params['tenant_id'] = query.tenant_id;
  if (query?.product_id) params['product_id'] = query.product_id;
  if (query?.product_slug) params['product_slug'] = query.product_slug;
  if (query?.plan_id) params['plan_id'] = query.plan_id;
  if (query?.search) params['search'] = query.search;
  if (query?.from) params['from'] = query.from;
  if (query?.to) params['to'] = query.to;

  const res = await apiClient.get<ApiResponse<AdminInstapayReviewsListResponse>>(
    '/api/v1/admin/payments/instapay/reviews',
    { params },
  );
  return res.data;
}

export async function approveInstapayPayment(
  paymentId: string,
  body: ReviewInstapayPaymentBody,
): Promise<AdminInstapayReviewItem> {
  const res = await apiClient.post<ApiResponse<AdminInstapayReviewItem>>(
    `/api/v1/admin/payments/instapay/${paymentId}/approve`,
    body,
  );
  return res.data;
}

export async function rejectInstapayPayment(
  paymentId: string,
  body: ReviewInstapayPaymentBody,
): Promise<AdminInstapayReviewItem> {
  const res = await apiClient.post<ApiResponse<AdminInstapayReviewItem>>(
    `/api/v1/admin/payments/instapay/${paymentId}/reject`,
    body,
  );
  return res.data;
}
